import * as type from './types'



export function savedVtype(vtype) {
    return {
        type : type.SAVED_VTYPE,
        payload : vtype,
        txn : 'success',
        diff : true
    };
}


export function editVtype(vtype) {
    return {
        type : type.EDIT_VTYPE,
        payload : vtype,
        txn : 'initiated',
    };
}


export function updateVtypeLoc(vtype) {
    return {
        type : type.UPDATE_VTYPE_LOC,
        payload : vtype,
    };
}


export function fetchVtype() {
    return {
        type : type.FETCH_VTYPE,
    };
}


export function fetchedVtype(vtype) {
    return {
        type : type.FETCHED_VTYPE,
        payload : vtype
    };
}

export function saveVtypeEditedRes(vtype) {
    return {
        type : type.SAVED_VTYPE_RES,
        payload : vtype
    };
}

export function deleteVtype(vtype) {
    return {
        type : type.DELETE_VTYPE,
        payload: vtype
    };
}


export function deletedVtype(msg) {
    return {
        type : type.DELETED_VTYPE,
        payload : msg
    };
}


export function setNotifyDone(props) {
    return {
        type : type.NOTIFICATION_DONE_VTYPE,
        payload: props
    };
}

